import { useState, memo } from "react";
import { Form, Row, Col, FloatingLabel } from "react-bootstrap";

import ButtonComponent from "./ButtonComponent";
import DateTimePicker from "./DateTimePicker";

type PresencesFormProps = {
  cities: string[];
  buildings: string[];
  rooms: string[];
  getBuildings: (city: string) => void;
  getRooms: (city: string, building: string) => void;
  getPresences: (
    city: string,
    room: string,
    building: string,
    startDate: Date,
    endDate: Date
  ) => void;
};

const PresencesForm = ({
  cities,
  buildings,
  rooms,
  getBuildings,
  getRooms,
  getPresences,
}: PresencesFormProps) => {
  const [city, setCity] = useState("");
  const [building, setBuilding] = useState("");
  const [room, setRoom] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const selects = [
    {
      topic: "city",
      value: city,
      data: cities,
      onChange: (value: string) => {
        setCity(value);
        getBuildings(value);
      },
    },
    {
      topic: "building",
      value: building,
      data: buildings,
      onChange: (value: string) => {
        setBuilding(value);
        getRooms(city, value);
      },
    },
    {
      topic: "room",
      value: room,
      data: rooms,
      onChange: (value: string) => setRoom(value),
    },
  ];

  const pickers = [
    {
      value: startDate,
      label: "Start date",
      setValue: setStartDate,
    },
    {
      value: endDate,
      label: "End date",
      setValue: setEndDate,
    },
  ];

  return (
    <Row>
      <Row className="justify-content-md-center mt-4">
        {selects.map(({ topic, value, onChange, data }, index) => (
          <Form.Group key={index} as={Col} md={3} controlId={`select${index}`}>
            <FloatingLabel
              controlId="floatingSelectGrid"
              label={topic.charAt(0).toUpperCase() + topic.slice(1)}
            >
              <Form.Control
                as="select"
                data-testid={`select-${topic}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
              >
                <option>Select {topic}</option>
                {data.map((i, index) => (
                  <option value={i} key={index}>
                    {i}
                  </option>
                ))}
              </Form.Control>
            </FloatingLabel>
          </Form.Group>
        ))}
      </Row>
      <Row className="justify-content-center my-4">
        {pickers.map(({ value, label, setValue }, index) => (
          <Form.Group key={index} as={Col} md={3} controlId={`select-${label}`}>
            <DateTimePicker date={value} label={label} setDate={setValue} />
          </Form.Group>
        ))}
        <Form.Group as={Col} md={3} controlId="submit-button">
          <ButtonComponent
            data-testid="search-button"
            disabled={!room || !building || !city}
            onClick={() =>
              getPresences(city, room, building, startDate, endDate)
            }
          >
            Search presences
          </ButtonComponent>
        </Form.Group>
      </Row>
    </Row>
  );
};

export default memo(PresencesForm);
